import React from 'react';

import BasicCheckbox from 'components/BasicCheckbox';
import { DateHelpers } from 'helpers/date-helpers';

import './styles.css';

const ProfileItemRecommendation = props => {
  const {
    data: {
      Approved,
      Active,
      RecommendationID,
      RecommendationDate,
      RecommendationText,
      ReferrerName,
      ReferrerTitle,
      Answers,
    },
    editable = false,
    toggleFunc,
  } = props;

  const showToFirms = !!Number(Active);

  const handleShowToFirm = () => {
    toggleFunc(RecommendationID, !showToFirms);
  };

  return (
    <div className="profile-item-recommendation">
      {editable && (
        <div className="profile-item-recommendation__control">
          <BasicCheckbox
            value={showToFirms}
            singleRow
            checked={showToFirms}
            title="Show To Firms"
            name="ApplicationDeadline"
            controlFunc={handleShowToFirm}
            labelStyles={{
              fontFamily: 'Noto Sans, sans-serif',
              fontSize: '0.9286rem',
            }}
          />
        </div>
      )}

      <div className="profile-item-recommendation__content">
        <blockquote className="profile-item-recommendation__quote">
          <p className="profile-item-recommendation__text">
            {RecommendationText}
          </p>
          {Answers && (
            <div className="profile-item-recommendation__rating">
              {Answers.map((answer, index) => (
                <div
                  key={index}
                  className="profile-item-recommendation__rating-info"
                >
                  {answer}
                </div>
              ))}
            </div>
          )}
          <footer className="profile-item-recommendation__cite">
            {`— ${ReferrerName}, ${ReferrerTitle}, ${DateHelpers.getMonthNameDayYearFormat(
              RecommendationDate
            )} `}
          </footer>
        </blockquote>
        {typeof Approved !== 'undefined' && typeof showToFirms !== 'undefined' && (
          <div
            className={
              Number(Approved) === 1
                ? 'profile-item-recommendation__status'
                : 'profile-item-recommendation__status profile-item-recommendation__status--not-aproved'
            }
          >
            {!showToFirms ? 'Hidden' : ''}
            <br />
            {Number(Approved) === 1 ? 'Approved' : 'Not Approved'}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProfileItemRecommendation;
